import { Injectable, Output, EventEmitter, Directive } from '@angular/core';

@Directive()
@Injectable({
  providedIn: 'root'
})
export class TourActiveService {

  @Output() activateTourEvent: EventEmitter<{tourSection: string, isSideBarActivate: boolean; firstTime: boolean}> = new EventEmitter();
  @Output() endTourEvent: EventEmitter<any> = new EventEmitter();
  @Output() openTabEvent: EventEmitter<string> = new EventEmitter();

  constructor() {}

  activateTour(tourSection: string, isSideBarActivate: boolean, firstTime: boolean) {
    this.activateTourEvent.emit({tourSection, isSideBarActivate, firstTime});
  }

  endTour() {
    this.endTourEvent.emit();
  }

  openTab(tabName: string) {
    this.openTabEvent.emit(tabName);
  }
}
